import getHome from "@/app/actions/get-home";
import Link from "next/link";
import { Logo } from "../logo";
import { ScrollButton } from "./scroll-button";
import { SocialLinks } from "./social-links";
import { StoreButtons } from "./stores-buttons";
import { ServiceDesk } from "./service-desk";

export async function Footer() {
  const data = await getHome();
  const { rodape } = data;
  return (
    <footer className="bg-secondary p-8 font-semibold text-input">
      <div className="flex flex-col lg:flex-row justify-center lg:justify-between items-center lg:items-center gap-8 mx-auto container">
        <Link
          href="/"
          className="scale-100 hover:scale-105 transition-all duration-300"
        >
          <Logo color="white" className="hidden md:block w-[260px]" />
          <Logo color="white" className="px-8 w-full md:hidden" />
        </Link>
        <StoreButtons data={rodape.lojas} />
        <ServiceDesk data={rodape.servicedesk} />
        <SocialLinks data={rodape.redes} />
      </div>
      <ScrollButton />
    </footer>
  );
}
